<template>
  <span>
    <b-badge v-if="sample_count" :variant="variant" pill>
      {{ percent }}%
    </b-badge>
    <b-badge v-else variant="" pill>
      N/A
    </b-badge>
  </span>
</template>

<script>
export default {
  name: "SubmissionProgressBadge",
  props: {
    submission: {
      type: Object,
      default: () => null
    },
    status_name: {
      type: String,
      default: null
    }
  },
  computed: {
    sample_count() {
      return this.submission.getSamples().models.length;
    },
    variant() {
      return this.percent >= 100
        ? "success"
        : this.percent > 0
        ? "warning"
        : "danger"
    },
    percent() {
      const submission = this.submission;
      const status_name = this.status_name;
      
      let count = 0;

      submission.getSamples().models.forEach(sample => {
        let exists = false;

        sample.getSampleStatusLogs().models.forEach(log => {
          const status = log.getSampleStatus();

          if (status.status === status_name) {
            exists = true;
          }
        });
        if (exists) {
          count++;
        }
      });

      return Math.ceil((count / +this.sample_count) * 100);
    },
  },
};
</script>
